//import Swiper from 'swiper';

export default class Trash {
  constructor() {
    this.init();
    this.form = jQuery('.controller-header').find('form');
    this.action = jQuery(this.form).attr('data-action');
  }

  init() {
    this.mode = 'week';
    this.calendar = null;
    this.select = jQuery('.selectpicker').select2({
      placeholder: jQuery(this).attr('placeholder'),
      language: jQuery(this).attr('lang')
    });



    jQuery('.controller-header').find('form').submit(function( event ) {

      let year =  jQuery('[name="year"]:checked').val();
      let val = jQuery('#streets_'+year).val();

      document.body.style.cursor = 'wait';
      let url = this.action + '/' + val;
      if (year){
        url = url +'?year='+year;
      }
      window.location = url;
      event.preventDefault();
    }.bind(this));

    /*

    jQuery('select[name="year"]').on('select2:select', function (e) {
      jQuery('select[name="streets"]').val('').trigger('change');
    }.bind(this));



    jQuery('select[name="streets"]').on('select2:select', function (e) {
      let data = jQuery(e.target).val();
      let year = jQuery('select[name="year"]').val();
      this.submit(data, year);
    }.bind(this));

     */

    this.initCalendar(this.mode);

    document.addEventListener("tabChanged", function(e) {
      this.calendar.destroy();
      this.mode = e.detail.mode;
      this.initCalendar(this.mode);
    }.bind(this), false);



  }

  initCalendar(mode) {
    let options = null;

    if(mode === 'week') {
      options = {
        slidesPerView: 7,
        slidesPerGroup: 7,
        spaceBetween: 0,
        breakpoints: {
          480: {
            slidesPerView: 1,
            slidesPerGroup: 1,
          },
          769: {
            slidesPerView: 2,
            slidesPerGroup: 2,
          },
          1024: {
            slidesPerView: 4,
            slidesPerGroup: 4,
          },
          1300: {
            slidesPerView: 5,
            slidesPerGroup: 5,
          }
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        init: false
      };
    }
    else if(mode === 'month') {
      options = {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 0,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        init: false
      };
    }
    else if(mode === 'year') {
      options = {
        slidesPerView: 4,
        slidesPerGroup: 4,
        breakpoints: {
          480: {
            slidesPerView: 1,
            slidesPerGroup: 1,
          },
          769: {
            slidesPerView: 2,
            slidesPerGroup: 2,
          },
          1024: {
            slidesPerView: 4,
            slidesPerGroup: 4,
          },
        },
        spaceBetween: 0,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        init: false
      };
    }

    let slider = document.querySelector('.slider[data-mode="'+mode+'"]');
    if (slider){
      this.calendar = new Swiper(slider.querySelector('.swiper-container'), options);

      this.calendar.on('init', function() {
        current_time(this, mode);
      });

      this.calendar.init();

      this.calendar.on('slideChange', function() {
        current_time(this, mode);
      });

      this.calendar.mode = mode;
      let currentIndex = this.getIndex();
      this.calendar.slideTo(currentIndex, 0, true);

      this.calendar.on('slideNextTransitionEnd', function() {
        current_time(this, mode);
      });

      this.calendar.on('slidePrevTransitionEnd', function() {
        current_time(this, mode);
      });
    }

  }

  submit(val, year = null) {
    document.body.style.cursor = 'wait';
    let url = this.action + '/' + val;
    console.log(url);
    if (year){
      url = url +'?year='+year;
    }
    window.location = url;
  }

  getIndex() {
    let returnIndex = null;
    if(this.calendar.mode === "week" || this.calendar.mode === "month") {
      Array.prototype.forEach.call(this.calendar.slides, (slide, index) => {
        if(slide.dataset.active) {
          returnIndex = index;
        }
      });
    }

    return returnIndex;
  }

}

function current_time(calendar, mode) {

  const currentIndex = calendar.activeIndex;
  const slide = calendar.slides[currentIndex];
  const language = document.querySelector('.active-dates').dataset.locale;
  const startEl = document.querySelector('.active-start-date');
  const endEl = document.querySelector('.active-end-date');

  if(slide) {
    if (mode === "week") {
      const breakpoint = calendar.currentBreakpoint;
      const startDate = new Date(slide.dataset.start * 1000);
      const endDate = new Date(slide.dataset.start * 1000);
      let group = 1;

      if (breakpoint == "max") {
        group = calendar.params.slidesPerGroup;
      } else if (calendar.params.breakpoints) {
        group = calendar.params.breakpoints[breakpoint].slidesPerGroup;
      }

      const printBtn = document.querySelector('.tab-pane.active .btn-print');
      let url = new URL(printBtn.href);
      let query_string = url.search;
      let search_params = new URLSearchParams(query_string);
      let day = 60 * 60 * 24 * 1000;
      search_params.set('start', startDate.getTime().toString());
      search_params.set('end', (startDate.getTime() + ((group - 1) * day)).toString());
      url.search = search_params.toString();
      printBtn.href = url.toString();

      startDate.setDate(startDate.getDate());
      endDate.setDate(startDate.getDate() + (group - 1));

      let startMonth = startDate.toLocaleString(language, { month: 'short' });
      let endMonth = endDate.toLocaleString(language, { month: 'short' });

      startEl.innerHTML = startDate.getDate() + (startDate.getMonth() !== endDate.getMonth() ? ' ' + startMonth + ' ' : '');
      if(startDate.getFullYear() !== endDate.getFullYear()) {
        startEl.innerHTML += ' ' + startDate.getFullYear() ;
      }
      startEl.innerHTML += ' - ';

      if (currentIndex == 0){
        let offset = (jQuery('[data-active]').first().index());
        endDate.setDate(startDate.getDate() + (group - 1) - offset);
        if (startDate.getTime() == endDate.getTime()){
          startEl.innerHTML = '';
        }
      }


      endEl.innerHTML =  endDate.getDate() +' ' + endMonth + ' ' + endDate.getFullYear();



    }
    else if(mode === "month") {
      const startDate = new Date(slide.dataset.start * 1000);

      startDate.setDate(startDate.getDate());
      let startMonth = startDate.toLocaleString(language, { month: 'short' });

      let startMonthNbr = startDate.getMonth();

      const printBtn = document.querySelector('.tab-pane.active .btn-print');
      let url = new URL(printBtn.href);
      let query_string = url.search;
      let search_params = new URLSearchParams(query_string);
      search_params.set('start', currentIndex);
      search_params.set('end', 0);
      url.search = search_params.toString();
      printBtn.href = url.toString();

      var string = startMonth + ' ' + startDate.getFullYear();
      startEl.innerHTML = string[0].toUpperCase() + string.slice(1);
      endEl.innerHTML = "";

    }
    else if(mode === "year") {
      const startDate = new Date(slide.dataset.start * 1000);
      const endDate = new Date(slide.dataset.start * 1000);
      let group = calendar.params.slidesPerGroup;

      startDate.setMonth(startDate.getMonth());
      endDate.setMonth(startDate.getMonth() + (group - 1));

      let startMonth = startDate.toLocaleString(language, { month: 'short' });
      let endMonth = endDate.toLocaleString(language, { month: 'short' });

      var string = startMonth;
      startEl.innerHTML = string[0].toUpperCase() + string.slice(1);

      endEl.innerHTML = '- ' + endMonth + ' ' + endDate.getFullYear();
    }
  }


}